export default "/images/vendor/flag-icon-css/flags/4x3/zm.svg?79a41234f024ca5ab0a9ea130ab83b7b";